// extracted by mini-css-extract-plugin
module.exports = {"subFooter":"SubFooter_subFooter__3XY5G","divider":"SubFooter_divider__S6YQq"};